export default __webpack_public_path__ + "static/media/coupon-item-huibuh.7842961b.png";